import React from 'react';

import PublicGameStats, { PublicGameIntentionStats } from '../builder/PublicGameStats.js';
import { localizeFields } from '../builder/DynamicFields.js';
import { colorToArray, i18nIntl } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

const GroupDisplay = ({ items, ...props }) => {
	if(items.length == 0) return null;

	const icon = props?.icon ?? false;

	return (
		<div style={{ display:'grid', gap:'0.5em', justifyItems:'center' }}>
			{(icon !== false) && (
				<img src={icon} width="50px" alt="" />
			)}

			<h3 style={{ fontSize:'1.6em', marginBlockEnd:'0.5em' }}>
				<strong>{props.title}:</strong>
			</h3>

			<PublicGameIntentionStats
				{...props}
				items={items}
			/>
		</div>
	)
};

export const LikeDislikeStatsGlobal = ({ stage, ...props }) => {
	const players = localizeFields((props?.players ?? []), props.locale);
	const stats = props?.stats ?? [];

	const parseStats = () => {
		if(players.length == 0) return [];

		const _stats = [];

		players.map((player, i) => {
			const values = stats.find((s) => (s.id == player.id));

			const total_likes = parseInt(values?.like ?? 0);
			const total_dislikes = parseInt(values?.dislike ?? 0);

			const total = total_likes + total_dislikes;
			const score = (total_likes - total_dislikes) / total;

			_stats.push({
				id:player.id,
				name:player?.name ?? player.title,
				image:player.full_image,
				likes:total_likes,
				dislikes:total_dislikes,
				total,
				score,
			});
		});

		return _stats;
	};

	const parseAnswers = () => {
		if(players.length == 0) return [];

		const _answers = {};

		(props?.user_answer ?? []).map((answer) => {
			if(answer.type != 'like') return;
			_answers[answer.id] = {
				type:answer.type,
				time:answer.time,
			};
		});

		return _answers;
	};

	const players_with_amount = parseStats();
	const answered_by_user = parseAnswers();

	players_with_amount.sort((a, b) => {
		if(a.score > b.score) return -1;
		if(a.score < b.score) return 1;
		if(a.name < b.name) return -1;
		if(a.name > b.name) return 1;
		return 0;
	});

	const like_color = colorToArray(stage?.likedislike_like_color ?? 'rgba(120, 195, 0, 1)');
	const dislike_color = colorToArray(stage?.likedislike_dislike_color ?? 'rgba(215, 35, 60, 1)');

	return (
		<PublicGameStats
			{...props}
			is_multi={true}
			items={players_with_amount}
			actual_selection={answered_by_user}
			colors={{ likes:like_color, dislikes:dislike_color }}
			options={['likes', 'dislikes']}
		/>
	)
};

const LikeDislikeStats = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const players = localizeFields((props?.players ?? []), props.locale);
	const user_answer = props?.user_answer ?? [];
	const stats = props?.stats ?? [];
	const is_builder = props?.is_builder ?? false;

	const parseStats = () => {
		if(players.length == 0) return [];

		const _stats = [[], []];	// [[dislikes], [likes]]

		players.map((player, i) => {
			const values = stats.find((s) => (s.id == player.id));

			const answered_by_user = (user_answer.find((i) => (i.id == player.id))?.type ?? 'dislike') == 'like' ? 1 : 0;

			const total_likes = parseInt(values?.like ?? 0);
			const total_dislikes = parseInt(values?.dislike ?? 0);

			const total = (!is_builder) ? (total_likes + total_dislikes) : parseInt((i * 10 + 100) * Math.random());

			_stats[answered_by_user].push({
				id:player.id,
				name:player?.name ?? player.title,
				image:player.full_image,
				likes:total_likes,
				dislikes:total_dislikes,
				total,
			});
		});

		return _stats;
	};

	const players_with_amount = parseStats();

	const like_color = colorToArray(stage?.likedislike_like_color ?? 'rgba(120, 195, 0, 1)');
	const dislike_color = colorToArray(stage?.likedislike_dislike_color ?? 'rgba(215, 35, 60, 1)');

	return (
		<div style={{ display:'grid', gap:'5em', '--yes-color':like_color, '--no-color':dislike_color }}>
			<GroupDisplay
				{...props}
				items={players_with_amount[1]}
				icon={stage?.full_likedislike_like_image ?? false}
				title={i18n("Liked items", 'uppercase')}
			/>

			<GroupDisplay
				{...props}
				items={players_with_amount[0]}
				icon={stage?.full_likedislike_dislike_image ?? false}
				title={i18n("Disliked items", 'uppercase')}
			/>
		</div>
	)
};

export default injectIntl(LikeDislikeStats);